
	  <p class="profileDialogTitle">
		  This is how your profile is seen by others.<br/>
		  <span *ngIf="isTranslator">Make sure to fill in all relevant information to ensure high visibility.</span></p>
	  <mat-dialog-content>
		  <user-profile [userId]="userId"></user-profile>
	  </mat-dialog-content>
	  <mat-dialog-actions style="justify-content: center;">
		  <button (click)="closeDialog()">Close</button>
	  </mat-dialog-actions>